import {
    Box,
    Typography,
    useTheme,
    Button,
    Tooltip,
    Checkbox,
    FormGroup,
} from "@mui/material";

import LoadingButton from '@mui/lab/LoadingButton';
import { tokens } from "../../../theme";
import Switch from '@mui/material/Switch';
import { useState, useEffect, useMemo, useRef } from "react";


import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from '@material-ui/core/TextField';

import { djangoApi } from "../../../utils/axios/axios.utils";


import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ptBR } from 'dayjs/locale/pt-br'; // Import the Brazilian Portuguese locale
import 'dayjs/locale/pt-br'; // Ensure the locale is available
import dayjs from 'dayjs'; // Import Day.js for date handling

import Swal from "sweetalert2";

import useMediaQuery from '@mui/material/useMediaQuery';
// import { faLeaf } from "@fortawesome/free-solid-svg-icons";

import InputMask from 'react-input-mask';
import classes from './user-form.module.css'

import { useDispatch } from "react-redux";
import { insertNewSeller, setSellers, setSellersUpdated } from "../../../store/sellers/sellers.action";

import { Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';








const UserForm = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();

    const isMobile = useMediaQuery('(min-width: 800px)');

    const [newOne, setNewOne] = useState(true);

    const { handleClose, dataUser, setdataUserToEdit, modalOpen, onlyEmailData, setHasFormErrors } = props;

    useEffect(() => {
        if (dataUser.id > 0) {
            setNewOne(false)
        }
    }, [dataUser]);



    const [isLoading, setIsLoading] = useState(false);

    const TestaCPF = cpf => {
        if (cpf) {
            var Soma;
            var Resto;
            Soma = 0;
            const strCPF = cpf.replaceAll('.', '').replace('-', '').replaceAll('_', '')
            if (strCPF === "00000000000") return false;

            for (let i = 1; i <= 9; i++)
                Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
            Resto = Soma * 10 % 11;

            if (Resto === 10 || Resto === 11) Resto = 0;
            if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

            Soma = 0;
            for (let i = 1; i <= 10; i++)
                Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
            Resto = Soma * 10 % 11;

            if (Resto === 10 || Resto === 11) Resto = 0;
            if (Resto !== parseInt(strCPF.substring(10, 11))) return false;

            return true;
        }
    };

    const validationSchema = yup.object({
        email: yup
            .string('Insira seu e-mail')
            .email('Insira um e-mail válido')
            .required('E-mail é necessário...'),
        // .when('newOne', {
        //     is: false, 
        //     then: yup.string().test(
        //         'is-not-in-list',
        //         'Email já cadastrado',
        //         function (val) {
        //             return !onlyEmailData.includes(val)
        //         }
        //     ),
        //     otherwise: yup.string(), //
        // }),
        nome: yup
            .string('Insira o Nome da Vendedora')
            .required('Nome é Necessário...'),
        telefone: yup
            .string('Telefone de contato')
            .required("Telefone é Necessário...")
        // .min(11, "Minimo - Insira o DDD + Número")
        // .max(11, "Maximo - Insira o DDD + Número")
        ,
        telefone_secundario: yup
            .string('Telefone de contato')
        // .required("Telefone é Necessário...")
        // .min(10, "Insira o DDD + Número")
        // .max(11, "Insira o DDD + Número")
        ,
        cpf: yup
            .string('Cpf da vendedora')
            .min(11, "Insira um CPF Válido")
            .max(11, "Insira um CPF Válido")
            .test("validator-custom-name", function (value) {
                const validation = TestaCPF(value);
                if (validation === false) {
                    return this.createError({
                        path: this.path,
                        message:
                            "Por favor insira um CPF Válido"
                    });
                } else {
                    return true;
                }
            })
            .required("Cpf é Necessário..."),
        data_nascimento: yup
            .string()
            .nullable()
            .notRequired()
            .test('validate-date', function (val) {
                if (val === null) {
                    return true;
                }
                if (val === 'Invalid Date') {
                    return false;
                }
                return true;
            }),
        como_conheceu: yup
            .string()
            .nullable()
            .notRequired(),

        como_conheceu_outro: yup
            .string()
            .nullable()
            .when('como_conheceu', {
                is: 'outro',
                then: (schema) =>
                    schema.required('Descreva como conheceu a empresa'),
                otherwise: (schema) =>
                    schema.notRequired(),
            }),

        motivo_saida: yup
            .string()
            .nullable()
            .notRequired(),

        data_saida: yup
            .mixed()
            .nullable()
            .notRequired()
            .test(
                'validate-exit-date',
                'Insira uma data de saída válida',
                function (value) {
                    if (!value) {
                        return true;
                    }

                    return dayjs(value).isValid();
                }
            ),

    });







    // check if telefone , cpf or e-mail já existem

    const initialValues = {
        id: '',
        nome: '',
        email: '',
        cpf: '',
        telefone: '',
        telefone_secundario: '',

        firebase_is_active: true,
        firebase_admin: false,
        firebase_isStaff: false,
        firebase_isOfficeStaff: false,

        insta_link: '',
        data_nascimento: null,
        firebase_category: 'vendedora',

        end_logradouro: '',
        end_complemento: '',
        end_cep: '',
        end_numero: '',
        end_municipio: '',
        end_bairro: '',

        end_logradouro_comercial: '',
        end_complemento_comercial: '',
        end_cep_comercial: '',
        end_numero_comercial: '',
        end_municipio_comercial: '',
        end_bairro_comercial: '',
        nome_empresa: '',

        end_logradouro_entrega: '',
        end_complemento_entrega: '',
        end_cep_entrega: '',
        end_numero_entrega: '',
        end_municipio_entrega: '',
        end_bairro_entrega: '',

        observacao: '',
        nome_mae: '',

        como_conheceu: '',
        como_conheceu_outro: '',
        motivo_saida: '',
        data_saida: null,
    };

    // const initialValues = {
    //     id: '',
    //     nome: 'marcelo',
    //     email: 'mtpata@icloud.com',
    //     cpf: '01924288027',
    //     telefone: '51997090861',
    //     telefone_secundario: '',
    //     firebase_is_active: true,
    //     insta_link: 'marcelo_pata',
    //     data_nascimento: null,
    //     firebase_category: 'vendedora',
    //     end_logradouro: 'rua doutor arnaldo da silva ferreira',
    //     end_complemento: '285',
    //     end_cep: '91760080',
    //     end_numero: '91',
    //     end_municipio: 'poa',
    //     end_bairro: 'vila nova',
    //     end_logradouro_comercial: '',
    //     end_complemento_comercial: '',
    //     end_cep_comercial: '',
    //     end_numero_comercial: '',
    //     end_municipio_comercial: '',
    //     end_bairro_comercial: '',
    //     observacao: 'algumas observacoes'

    // }


    const sendUserData = async (userData) => {
        setIsLoading(true)
        const params = userData
        console.log('params enviado', params)
        try {
            await djangoApi
                .post("sellers/sellers/save_and_update_user/", params, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`
                    }
                })
                .then((res) => {
                    console.log(res.data)
                    console.log(res.status)
                    if (res.status === 201) {
                        const { data, user_created } = res.data
                        dispatch(insertNewSeller(data))
                        const newUser = JSON.parse(user_created)
                        Swal.fire({
                            title: "Feito!!",
                            text: `${newUser.nome}: ${newUser.email} Cadastrado com sucesso!!`,
                            icon: "success"
                        });
                        handleClearAll()
                    } else if (res.status === 200) {
                        const { data, user_updated } = res.data
                        dispatch(setSellersUpdated(data))
                        const newUser = JSON.parse(user_updated)
                        Swal.fire({
                            title: "Feito!!",
                            text: `${newUser.nome}: ${newUser.email} Alterado com sucesso!!`,
                            icon: "info"
                        });
                        handleClearAll()
                    } else if (res.status === 208) {
                        const { msg, error } = res.data
                        setHasFormErrors(true)
                        Swal.fire({
                            title: `${msg}`,
                            text: `${error}!!`,
                            icon: "error",
                            showCloseButton: true,
                            customClass: {
                                popup: classes.swalcustomzindex,
                            },
                            didOpen: () => {
                                // Directly modify the z-index of the SweetAlert2 popup
                                const swalPopup = document.querySelector('.swal2-popup');
                                if (swalPopup) {
                                    swalPopup.style.zIndex = '2100 !important'; // Ensure this is higher than any MUI modal z-index
                                }
                            },
                            willClose: () => {
                                console.log('Alert will be closed');
                                // Call your custom function here
                                setHasFormErrors(false)
                            }
                        });
                    }
                });
        } catch (err) {
            console.log("Erro ao enviar os dados", err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }
    };

    const formInitialValues = useMemo(() => {
        if (dataUser?.id) {
            return {
                ...initialValues,
                ...dataUser,

                telefone: dataUser.telefone || '',
                telefone_secundario: dataUser.telefone_secundario || '',

                data_nascimento: dataUser.data_nascimento || null,
                data_saida: dataUser.data_saida || null,

                como_conheceu: dataUser.como_conheceu || '',
                como_conheceu_outro:
                    dataUser.como_conheceu_outro || '',

                motivo_saida: dataUser.motivo_saida || '',

                firebase_is_active:
                    dataUser.firebase_is_active ?? true,

                firebase_admin:
                    dataUser.firebase_admin ?? false,

                firebase_isStaff:
                    dataUser.firebase_isStaff ?? false,

                firebase_isOfficeStaff:
                    dataUser.firebase_isOfficeStaff ?? false,
            };
        }

        return initialValues;
    }, [dataUser, modalOpen]);


    const formik = useFormik({
        initialValues: formInitialValues,
        enableReinitialize: true,
        validationSchema,

        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: true,

        onSubmit: (values) => {
            const cleanStringToNumbers = (input) => {
                return input ? String(input).replace(/\D/g, '') : '';
            };

            const valuesToSend = {
                ...initialValues,
                ...values,

                telefone: cleanStringToNumbers(values.telefone),

                telefone_secundario:
                    cleanStringToNumbers(
                        values.telefone_secundario
                    ),

                data_nascimento:
                    values.data_nascimento &&
                        dayjs(values.data_nascimento).isValid()
                        ? dayjs(values.data_nascimento).format(
                            'YYYY-MM-DD'
                        )
                        : null,

                data_saida:
                    values.data_saida &&
                        dayjs(values.data_saida).isValid()
                        ? dayjs(values.data_saida).format(
                            'YYYY-MM-DD'
                        )
                        : null,
            };

            console.log('data before submit:', valuesToSend);

            sendUserData(valuesToSend);
        },
    });

    const previousDataSaidaRef = useRef(formik.values.data_saida);
    const previousFirebaseIsActiveRef = useRef(formik.values.firebase_is_active);
    const didInitializeExitRulesRef = useRef(false);

    useEffect(() => {
        previousDataSaidaRef.current = formik.values.data_saida;
        previousFirebaseIsActiveRef.current = formik.values.firebase_is_active;
        didInitializeExitRulesRef.current = false;
    }, [
        formik.values.id,
        modalOpen,
    ]);

    const handleComoConheceuChange = (option) => {
        const alreadySelected = formik.values.como_conheceu === option;

        formik.setFieldValue(
            'como_conheceu',
            alreadySelected ? '' : option
        );

        if (option !== 'outro' || alreadySelected) {
            formik.setFieldValue('como_conheceu_outro', '');
        }
    };

    useEffect(() => {
        const currentDataSaida = formik.values.data_saida;
        const previousDataSaida = previousDataSaidaRef.current;

        const currentFirebaseIsActive = formik.values.firebase_is_active;
        const previousFirebaseIsActive = previousFirebaseIsActiveRef.current;

        /*
         * Ignora a primeira passada após abrir/reinicializar o form.
         * Isso evita alterar uma vendedora só por abrir o modal.
         */
        if (!didInitializeExitRulesRef.current) {
            didInitializeExitRulesRef.current = true;
            previousDataSaidaRef.current = currentDataSaida;
            previousFirebaseIsActiveRef.current = currentFirebaseIsActive;
            return;
        }

        /*
         * REGRA 1:
         * Se marcou data de saída, inativa a vendedora.
         */
        const dataSaidaWasAdded =
            !previousDataSaida &&
            Boolean(currentDataSaida);

        if (
            dataSaidaWasAdded &&
            currentFirebaseIsActive === true
        ) {
            formik.setFieldValue(
                "firebase_is_active",
                false,
                false
            );
        }

        /*
         * REGRA 2:
         * Se inativou a vendedora manualmente,
         * e ainda não existe data de saída,
         * marca a data de hoje.
         */
        const wasManuallyInactivated =
            previousFirebaseIsActive === true &&
            currentFirebaseIsActive === false;

        if (
            wasManuallyInactivated &&
            !currentDataSaida
        ) {
            formik.setFieldValue(
                "data_saida",
                dayjs().format("YYYY-MM-DD"),
                false
            );
        }

        previousDataSaidaRef.current = currentDataSaida;
        previousFirebaseIsActiveRef.current = currentFirebaseIsActive;
    }, [
        formik.values.data_saida,
        formik.values.firebase_is_active,
    ]);



    const formData = [
        { id: 'nome', name: 'nome', type: 'text', maxlenght: '', label: 'Nome', value: formik.values.nome, error: formik.touched.nome && Boolean(formik.errors.nome), helpertext: formik.touched.nome && formik.errors.nome },
        { id: 'email', name: 'email', type: 'text', maxlenght: '', label: 'Email', value: formik.values.email, error: formik.touched.email && Boolean(formik.errors.email), helpertext: formik.touched.email && formik.errors.email },
        { id: 'cpf', name: 'cpf', type: 'tel', maxlenght: '11', label: 'Cpf', value: formik.values.cpf, error: formik.touched.cpf && Boolean(formik.errors.cpf), helpertext: formik.touched.cpf && formik.errors.cpf },
        { id: 'data_nascimento', name: 'data_nascimento', type: 'text', maxlenght: '', label: 'Data Nascimento', value: formik.values.data_nascimento, error: formik.touched.data_nascimento && Boolean(formik.errors.data_nascimento), helpertext: formik.touched.data_nascimento && formik.errors.data_nascimento },
        { id: 'telefone', name: 'telefone', type: 'tel', maxlenght: '', label: 'Telefone', value: formik.values.telefone, error: formik.touched.telefone && Boolean(formik.errors.telefone), helpertext: formik.touched.telefone && formik.errors.telefone },
        { id: 'telefone_secundario', name: 'telefone_secundario', type: 'tel', maxlenght: '', label: 'Telefone 2', value: formik.values.telefone_secundario, error: formik.touched.telefone_secundario && Boolean(formik.errors.telefone_secundario), helpertext: formik.touched.telefone_secundario && formik.errors.telefone_secundario },
        { id: 'insta_link', name: 'insta_link', type: 'text', maxlenght: '', label: 'Usuário do Instagram', value: formik.values.insta_link, error: formik.touched.insta_link && Boolean(formik.errors.insta_link), helpertext: formik.touched.insta_link && formik.errors.insta_link },
        { id: 'nome_mae', name: 'nome_mae', type: 'text', maxlenght: '', label: 'Nome da Mãe da Vendedora', value: formik.values.nome_mae, error: formik.touched.nome_mae && Boolean(formik.errors.nome_mae), helpertext: formik.touched.nome_mae && formik.errors.nome_mae },
        { id: 'firebase_is_active', name: 'firebase_is_active', type: 'text', maxlenght: '', label: 'Ativo', value: formik.values.firebase_is_active, error: formik.touched.firebase_is_active && Boolean(formik.errors.firebase_is_active), helpertext: formik.touched.firebase_is_active && formik.errors.firebase_is_active },
        { id: 'firebase_admin', name: 'firebase_admin', type: 'text', maxlenght: '', label: 'Admin', value: formik.values.firebase_admin, error: formik.touched.firebase_admin && Boolean(formik.errors.firebase_admin), helpertext: formik.touched.firebase_admin && formik.errors.firebase_admin },
        { id: 'firebase_isOfficeStaff', name: 'firebase_isOfficeStaff', type: 'text', maxlenght: '', label: 'Office Staff', value: formik.values.firebase_isOfficeStaff, error: formik.touched.firebase_isOfficeStaff && Boolean(formik.errors.firebase_isOfficeStaff), helpertext: formik.touched.firebase_isOfficeStaff && formik.errors.firebase_isOfficeStaff },
        { id: 'firebase_isStaff', name: 'firebase_isStaff', type: 'text', maxlenght: '', label: 'Super Admin', value: formik.values.firebase_isStaff, error: formik.touched.firebase_isStaff && Boolean(formik.errors.firebase_isStaff), helpertext: formik.touched.firebase_isStaff && formik.errors.firebase_isStaff },
        // { id: 'category', name: 'category', type: 'text', maxlenght: '', label: 'Categoria', value: formik.values.category, error: formik.touched.category && Boolean(formik.errors.category), helpertext: formik.touched.category && formik.errors.category },
    ]
    const formDataStreet = [
        { id: 'end_logradouro', name: 'end_logradouro', type: 'text', maxlenght: '', label: 'Logradouro', value: formik.values.end_logradouro, error: formik.touched.end_logradouro && Boolean(formik.errors.end_logradouro), helpertext: formik.touched.end_logradouro && formik.errors.end_logradouro },
        { id: 'end_numero', name: 'end_numero', type: 'tel', maxlenght: '', label: 'Número', value: formik.values.end_numero, error: formik.touched.end_numero && Boolean(formik.errors.end_numero), helpertext: formik.touched.end_numero && formik.errors.end_numero },
        { id: 'end_complemento', name: 'end_complemento', type: 'text', maxlenght: '', label: 'Complemento', value: formik.values.end_complemento, error: formik.touched.end_complemento && Boolean(formik.errors.end_complemento), helpertext: formik.touched.end_complemento && formik.errors.end_complemento },
        { id: 'end_cep', name: 'end_cep', type: 'tel', maxlenght: '8', label: 'Cep', value: formik.values.end_cep, error: formik.touched.end_cep && Boolean(formik.errors.end_cep), helpertext: formik.touched.end_cep && formik.errors.end_cep },
        { id: 'end_bairro', name: 'end_bairro', type: 'text', maxlenght: '', label: 'Bairro', value: formik.values.end_bairro, error: formik.touched.end_bairro && Boolean(formik.errors.end_bairro), helpertext: formik.touched.end_bairro && formik.errors.end_bairro },
        { id: 'end_municipio', name: 'end_municipio', type: 'text', maxlenght: '', label: 'Municipio', value: formik.values.end_municipio, error: formik.touched.end_municipio && Boolean(formik.errors.end_municipio), helpertext: formik.touched.end_municipio && formik.errors.end_municipio },
    ]
    const formDataStreetComercial = [
        { id: 'nome_empresa', name: 'nome_empresa', type: 'text', maxlenght: '', label: 'Nome Empresa', value: formik.values.nome_empresa, error: formik.touched.nome_empresa && Boolean(formik.errors.nome_empresa), helpertext: formik.touched.nome_empresa && formik.errors.nome_empresa },
        { id: 'end_logradouro_comercial', name: 'end_logradouro_comercial', type: 'text', maxlenght: '', label: 'Logradouro', value: formik.values.end_logradouro_comercial, error: formik.touched.end_logradouro_comercial && Boolean(formik.errors.end_logradouro_comercial), helpertext: formik.touched.end_logradouro_comercial && formik.errors.end_logradouro_comercial },
        { id: 'end_numero_comercial', name: 'end_numero_comercial', type: 'tel', maxlenght: '', label: 'Número', value: formik.values.end_numero_comercial, error: formik.touched.end_numero_comercial && Boolean(formik.errors.end_numero_comercial), helpertext: formik.touched.end_numero_comercial && formik.errors.end_numero_comercial },
        { id: 'end_complemento_comercial', name: 'end_complemento_comercial', type: 'text', maxlenght: '', label: 'Complemento', value: formik.values.end_complemento_comercial, error: formik.touched.end_complemento_comercial && Boolean(formik.errors.end_complemento_comercial), helpertext: formik.touched.end_complemento_comercial && formik.errors.end_complemento_comercial },
        { id: 'end_cep_comercial', name: 'end_cep_comercial', type: 'tel', maxlenght: '8', label: 'Cep', value: formik.values.end_cep_comercial, error: formik.touched.end_cep_comercial && Boolean(formik.errors.end_cep_comercial), helpertext: formik.touched.end_cep_comercial && formik.errors.end_cep_comercial },
        { id: 'end_bairro_comercial', name: 'end_bairro_comercial', type: 'text', maxlenght: '', label: 'Bairro', value: formik.values.end_bairro_comercial, error: formik.touched.end_bairro_comercial && Boolean(formik.errors.end_bairro_comercial), helpertext: formik.touched.end_bairro_comercial && formik.errors.end_bairro_comercial },
        { id: 'end_municipio_comercial', name: 'end_municipio_comercial', type: 'text', maxlenght: '', label: 'Municipio', value: formik.values.end_municipio_comercial, error: formik.touched.end_municipio_comercial && Boolean(formik.errors.end_municipio_comercial), helpertext: formik.touched.end_municipio_comercial && formik.errors.end_municipio_comercial },
    ]

    const formDataStreetEntrega = [
        { id: 'end_logradouro_entrega', name: 'end_logradouro_entrega', type: 'text', maxlenght: '', label: 'Logradouro', value: formik.values.end_logradouro_entrega, error: formik.touched.end_logradouro_entrega && Boolean(formik.errors.end_logradouro_entrega), helpertext: formik.touched.end_logradouro_entrega && formik.errors.end_logradouro_entrega },
        { id: 'end_numero_entrega', name: 'end_numero_entrega', type: 'tel', maxlenght: '', label: 'Número', value: formik.values.end_numero_entrega, error: formik.touched.end_numero_entrega && Boolean(formik.errors.end_numero_entrega), helpertext: formik.touched.end_numero_entrega && formik.errors.end_numero_entrega },
        { id: 'end_complemento_entrega', name: 'end_complemento_entrega', type: 'text', maxlenght: '', label: 'Complemento', value: formik.values.end_complemento_entrega, error: formik.touched.end_complemento_entrega && Boolean(formik.errors.end_complemento_entrega), helpertext: formik.touched.end_complemento_entrega && formik.errors.end_complemento_entrega },
        { id: 'end_cep_entrega', name: 'end_cep_entrega', type: 'tel', maxlenght: '8', label: 'Cep', value: formik.values.end_cep_entrega, error: formik.touched.end_cep_entrega && Boolean(formik.errors.end_cep_entrega), helpertext: formik.touched.end_cep_entrega && formik.errors.end_cep_entrega },
        { id: 'end_bairro_entrega', name: 'end_bairro_entrega', type: 'text', maxlenght: '', label: 'Bairro', value: formik.values.end_bairro_entrega, error: formik.touched.end_bairro_entrega && Boolean(formik.errors.end_bairro_entrega), helpertext: formik.touched.end_bairro_entrega && formik.errors.end_bairro_entrega },
        { id: 'end_municipio_entrega', name: 'end_municipio_entrega', type: 'text', maxlenght: '', label: 'Municipio', value: formik.values.end_municipio_entrega, error: formik.touched.end_municipio_entrega && Boolean(formik.errors.end_municipio_entrega), helpertext: formik.touched.end_municipio_entrega && formik.errors.end_municipio_entrega },
    ]

    const handleClearAll = () => {
        formik.resetForm({
            values: initialValues,
        });

        setdataUserToEdit(initialValues);
        handleClose();
    };





    const [selectedValue, setSelectedValue] = useState('');

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    };


    useEffect(() => {
        const {
            end_logradouro_entrega,
            end_complemento_entrega,
            end_cep_entrega,
            end_numero_entrega,
            end_municipio_entrega,
            end_bairro_entrega,

            end_logradouro,
            end_complemento,
            end_cep,
            end_numero,
            end_municipio,
            end_bairro,

            end_logradouro_comercial,
            end_complemento_comercial,
            end_cep_comercial,
            end_numero_comercial,
            end_municipio_comercial,
            end_bairro_comercial,
        } = formik.values;

        const fieldsEntrega = [
            end_logradouro_entrega,
            end_complemento_entrega,
            end_cep_entrega,
            end_numero_entrega,
            end_municipio_entrega,
            end_bairro_entrega,
        ];

        const fieldsResidencial = [
            end_logradouro,
            end_complemento,
            end_cep,
            end_numero,
            end_municipio,
            end_bairro,
        ];

        const fieldsComercial = [
            end_logradouro_comercial,
            end_complemento_comercial,
            end_cep_comercial,
            end_numero_comercial,
            end_municipio_comercial,
            end_bairro_comercial,
        ];

        const areEqual = (a, b) =>
            a.every((val, i) => (val || '').trim() === (b[i] || '').trim());

        const allEntregaEmpty = fieldsEntrega.every((f) => !f?.trim());

        if (allEntregaEmpty) {
            setSelectedValue('outro');
        } else if (areEqual(fieldsEntrega, fieldsResidencial)) {
            setSelectedValue('residencial');
        } else if (areEqual(fieldsEntrega, fieldsComercial)) {
            setSelectedValue('comercial');
        } else {
            setSelectedValue('outro');
        }
    }, []);


    useEffect(() => {
        if (selectedValue === 'comercial') {
            formik.setFieldValue('end_logradouro_entrega', formik.values.end_logradouro_comercial || '');
            formik.setFieldValue('end_complemento_entrega', formik.values.end_complemento_comercial || '');
            formik.setFieldValue('end_cep_entrega', formik.values.end_cep_comercial || '');
            formik.setFieldValue('end_numero_entrega', formik.values.end_numero_comercial || '');
            formik.setFieldValue('end_municipio_entrega', formik.values.end_municipio_comercial || '');
            formik.setFieldValue('end_bairro_entrega', formik.values.end_bairro_comercial || '');
        }

        if (selectedValue === 'residencial') {
            formik.setFieldValue('end_logradouro_entrega', formik.values.end_logradouro || '');
            formik.setFieldValue('end_complemento_entrega', formik.values.end_complemento || '');
            formik.setFieldValue('end_cep_entrega', formik.values.end_cep || '');
            formik.setFieldValue('end_numero_entrega', formik.values.end_numero || '');
            formik.setFieldValue('end_municipio_entrega', formik.values.end_municipio || '');
            formik.setFieldValue('end_bairro_entrega', formik.values.end_bairro || '');
        }
        if (selectedValue === 'outro') {
            formik.setFieldValue('end_logradouro_entrega', '');
            formik.setFieldValue('end_complemento_entrega', '');
            formik.setFieldValue('end_cep_entrega', '');
            formik.setFieldValue('end_numero_entrega', '');
            formik.setFieldValue('end_municipio_entrega', '');
            formik.setFieldValue('end_bairro_entrega', '');
        }
    }, [
        selectedValue,
        formik.values.end_logradouro,
        formik.values.end_complemento,
        formik.values.end_cep,
        formik.values.end_numero,
        formik.values.end_municipio,
        formik.values.end_bairro,

        formik.values.end_logradouro_comercial,
        formik.values.end_complemento_comercial,
        formik.values.end_cep_comercial,
        formik.values.end_numero_comercial,
        formik.values.end_municipio_comercial,
        formik.values.end_bairro_comercial,
    ]); // depende do selectedValue

    return (
        <Box
        >
            <Typography variant="h4" color={colors.pink[600]} fontWeight={'bold'} pb={1}>Dados da Vendedora</Typography>
            <form onSubmit={formik.handleSubmit} style={{ gap: '0px', display: 'flex', flexDirection: 'column' }}>
                {
                    formData.filter((data) => !['firebase_is_active', 'firebase_admin', 'firebase_isStaff', 'firebase_isOfficeStaff'].includes((data.id))).map((data, index) => {
                        if (data.id === 'data_nascimento') {
                            return (
                                <Box
                                    sx={{
                                        width: '100%', // Full width
                                        // height: 'calc(100vh - 20px)', // Full height minus some padding
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        margin: '4px',
                                    }}
                                >

                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br"

                                    > {/* Set adapterLocale to 'pt-br' */}
                                        <DatePicker
                                            label={data.label}
                                            value={data.value ? dayjs(data.value) : null}
                                            onChange={(value) => formik.setFieldValue(data.name, value)} // Ensure the field name matches Formik's state
                                            sx={{
                                                width: '100%',
                                                height: '40px',
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    error={formik.touched[data.name] && Boolean(formik.errors[data.name])}
                                                    helperText={formik.touched[data.name] && formik.errors[data.name]}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            )
                        }
                        if (data.name === 'telefone' && !newOne) {
                            return (

                                <TextField
                                    style={{ margin: '4px', marginTop: data.name === 'telefone' ? '18px' : '7px' }}
                                    variant="outlined"
                                    size="small"
                                    key={data.id}
                                    fullWidth
                                    id={data.id}
                                    name={data.name}
                                    label={data.label}
                                    value={data.value}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={data.error}
                                    helperText={data.helpertext}
                                    // disabled={!newOne}
                                    type={data.type}
                                    inputProps={{
                                        maxLength: data.maxlenght,
                                    }}
                                />
                            )
                        }
                        if (data.name === 'telefone' || data.name === 'telefone_secundario') {
                            return (
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={data.value}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    key={data.id}
                                >
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            style={{ margin: '4px', marginTop: data.name === 'telefone' ? '18px' : '7px' }}
                                            fullWidth
                                            id={data.id}
                                            name={data.name}
                                            variant="outlined"
                                            size="small"
                                            label={data.label}
                                            error={data.error}
                                            helperText={data.helpertext}
                                            margin="normal"
                                            type={data.type}
                                            inputProps={{
                                                maxLength: data.maxlenght,
                                            }}
                                        />
                                    )}
                                </InputMask>
                            )
                        }
                        if (data.name === 'cspf') {
                            return (
                                <InputMask
                                    mask="999.999.999-99"
                                    value={data.value}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    key={data.id}
                                >
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            fullWidth
                                            id={data.id}
                                            name={data.name}
                                            variant="outlined"
                                            size="small"
                                            label="Cpf"
                                            error={data.error}
                                            helperText={data.helpertext}
                                            margin="normal"
                                        />
                                    )}
                                </InputMask>
                            )
                        }
                        return (
                            <TextField
                                style={{ margin: '4px', marginTop: data.name === 'telefone' ? '18px' : '7px' }}
                                variant="outlined"
                                size="small"
                                key={data.id}
                                fullWidth
                                id={data.id}
                                name={data.name}
                                label={data.label}
                                value={data.value}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={data.error}
                                helperText={data.helpertext}
                                // disabled={!newOne && (data.name === 'telefone' || data.name === 'email')}
                                type={data.type}
                                inputProps={{
                                    maxLength: data.maxlenght,
                                }}
                            />
                        )
                    })
                }
                <Typography variant="h4" color={colors.pink[600]} fontWeight={'bold'} pb={1} mt={2}>Permissões</Typography>
                <Box fullWidth
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '80px',
                        backgroundColor: 'rgba(214,211,200,0.5)',
                        borderRadius: '4px',
                        border: '1px rgba(0,0,0,0.2) solid',
                        marginLeft: '5px',
                        marginRight: '-4px',
                        padding: '6px 0px 6px 20px'
                    }}
                    mb={2}
                >

                    {
                        formData.filter((data) => ['firebase_is_active', 'firebase_admin', 'firebase_isStaff', 'firebase_isOfficeStaff'].includes((data.id))).map((data, index) => {
                            if (data.id === 'firebase_is_active') {
                                return (

                                    <Tooltip title="Ative ou desative o acesso do Usuário ao sistema" arrow
                                        PopperProps={{
                                            modifiers: [
                                                {
                                                    name: "preventOverflow",
                                                    options: {
                                                        boundary: "window",
                                                    },
                                                },
                                            ],
                                        }}
                                        componentsProps={{
                                            tooltip: {
                                                sx: { fontSize: '0.9rem', padding: '2px', backgroundColor: 'rgba(51,51,51,0.8)' },
                                            },
                                        }}
                                    >
                                        <Box key={data.id} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <Typography color={colors.primary[400]} fontWeight={"bold"}>{data.label}</Typography>
                                            <Switch
                                                checked={data.value ?? true}
                                                onChange={(event) => formik.setFieldValue('firebase_is_active', event.target.checked)}
                                                name="firebase_is_active"
                                                color="success"
                                                id="firebase_is_active"
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        </Box>
                                    </Tooltip>
                                )
                            }
                            if (data.id === 'firebase_admin') {
                                return (

                                    <Tooltip title="Acesso ao Painel de Admin do sistema" arrow
                                        PopperProps={{
                                            modifiers: [
                                                {
                                                    name: "preventOverflow",
                                                    options: {
                                                        boundary: "window",
                                                    },
                                                },
                                            ],
                                        }}
                                        componentsProps={{
                                            tooltip: {
                                                sx: { fontSize: '0.9rem', padding: '2px', backgroundColor: 'rgba(51,51,51,0.8)' },
                                            },
                                        }}
                                    >
                                        <Box key={data.id} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <Typography color={colors.primary[400]} fontWeight={"bold"}>{data.label}</Typography>
                                            <Switch
                                                checked={data.value}
                                                onChange={(event) => formik.setFieldValue('firebase_admin', event.target.checked)}
                                                name="firebase_admin"
                                                color="success"
                                                id="firebase_admin"
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        </Box>
                                    </Tooltip>
                                )
                            }
                            if (data.id === 'firebase_isStaff') {
                                return (
                                    <Tooltip title="Acesso a Sessão financeira e todas as demais funcionalidades" arrow
                                        PopperProps={{
                                            modifiers: [
                                                {
                                                    name: "preventOverflow",
                                                    options: {
                                                        boundary: "window",
                                                    },
                                                },
                                            ],
                                        }}
                                        componentsProps={{
                                            tooltip: {
                                                sx: { fontSize: '0.9rem', padding: '2px', backgroundColor: 'rgba(51,51,51,0.8)' },
                                            },
                                        }}
                                    >
                                        <Box key={data.id} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <Typography color={colors.primary[400]} fontWeight={"bold"}>{data.label}</Typography>
                                            <Switch
                                                checked={data.value}
                                                onChange={(event) => formik.setFieldValue('firebase_isStaff', event.target.checked)}
                                                name="firebase_isStaff"
                                                color="success"
                                                id="firebase_isStaff"
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        </Box>
                                    </Tooltip>
                                )
                            }
                            if (data.id === 'firebase_isOfficeStaff') {
                                return (
                                    <Tooltip title="Acesso a Sessão Admin Sem Acesso a Sessão Financeira" arrow
                                        PopperProps={{
                                            modifiers: [
                                                {
                                                    name: "preventOverflow",
                                                    options: {
                                                        boundary: "window",
                                                    },
                                                },
                                            ],
                                        }}
                                        componentsProps={{
                                            tooltip: {
                                                sx: { fontSize: '0.9rem', padding: '2px', backgroundColor: 'rgba(51,51,51,0.8)' },
                                            },
                                        }}
                                    >
                                        <Box key={data.id} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <Typography color={colors.primary[400]} fontWeight={"bold"}>{data.label}</Typography>

                                            <Switch
                                                checked={data.value}
                                                onChange={(event) => formik.setFieldValue('firebase_isOfficeStaff', event.target.checked)}
                                                name="firebase_isOfficeStaff"
                                                color="success"
                                                id="firebase_isOfficeStaff"
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        </Box>
                                    </Tooltip>
                                )
                            }
                            else {
                                return []
                            }
                        })
                    }
                </Box>

                <Typography
                    variant="h4"
                    color={colors.pink[600]}
                    fontWeight="bold"
                    pb={1}
                    mt={3}
                >
                    Vínculo com a Empresa
                </Typography>

                <Box
                    sx={{
                        margin: '4px',
                        padding: {
                            xs: '12px',
                            sm: '12px 16px',
                        },
                        borderRadius: '6px',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        backgroundColor: 'rgba(214, 211, 200, 0.28)',
                    }}
                >
                    <Typography
                        variant="body2"
                        fontWeight="bold"
                        color={colors.primary[400]}
                        mb={0.5}
                    >
                        Como nos conheceu?
                    </Typography>

                    <FormControl
                        component="fieldset"
                        error={
                            formik.touched.como_conheceu &&
                            Boolean(formik.errors.como_conheceu)
                        }
                        fullWidth
                    >
                        <FormGroup
                            row
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                columnGap: {
                                    xs: '4px',
                                    sm: '18px',
                                },
                                rowGap: '0px',
                            }}
                        >
                            {[
                                {
                                    value: 'anuncios',
                                    label: 'Anúncios',
                                },
                                {
                                    value: 'pesquisas',
                                    label: 'Pesquisas',
                                },
                                {
                                    value: 'indicacao',
                                    label: 'Indicação',
                                },
                                {
                                    value: 'outro',
                                    label: 'Outro',
                                },
                            ].map((option) => (
                                <FormControlLabel
                                    key={option.value}
                                    label={option.label}
                                    sx={{
                                        marginRight: {
                                            xs: '8px',
                                            sm: '12px',
                                        },
                                        color: colors.primary[400],
                                    }}
                                    control={
                                        <Checkbox
                                            color="success"
                                            size="small"
                                            checked={
                                                formik.values.como_conheceu ===
                                                option.value
                                            }
                                            onChange={() =>
                                                handleComoConheceuChange(
                                                    option.value
                                                )
                                            }
                                        />
                                    }
                                />
                            ))}
                        </FormGroup>
                    </FormControl>

                    {formik.values.como_conheceu === 'outro' && (
                        <TextField
                            fullWidth
                            id="como_conheceu_outro"
                            name="como_conheceu_outro"
                            label="Conte como nos conheceu"
                            placeholder="Ex.: evento, cliente, amiga, loja..."
                            variant="outlined"
                            size="small"
                            value={
                                formik.values.como_conheceu_outro || ''
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.como_conheceu_outro &&
                                Boolean(
                                    formik.errors.como_conheceu_outro
                                )
                            }
                            helperText={
                                formik.touched.como_conheceu_outro &&
                                formik.errors.como_conheceu_outro
                            }
                            sx={{
                                marginTop: '6px',
                                maxWidth: {
                                    xs: '100%',
                                    sm: '520px',
                                },
                            }}
                        />
                    )}
                </Box>

                <Typography
                    variant="h4"
                    color={colors.pink[600]}
                    fontWeight="bold"
                    pb={1}
                    mt={3}
                >
                    Saída ou Desistência
                </Typography>

                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: '190px minmax(260px, 1fr)',
                        },
                        gap: '10px',
                        alignItems: 'start',
                        margin: '4px',
                    }}
                >
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="pt-br"
                    >
                        <DatePicker
                            label="Data de saída"
                            value={
                                formik.values.data_saida
                                    ? dayjs(formik.values.data_saida)
                                    : null
                            }
                            onChange={(value) => {
                                formik.setFieldValue(
                                    'data_saida',
                                    value && value.isValid()
                                        ? value.format('YYYY-MM-DD')
                                        : null
                                );
                            }}
                            maxDate={dayjs()}
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: '170px',
                                },
                            }}
                            slotProps={{
                                textField: {
                                    variant: 'outlined',
                                    size: 'small',
                                    error:
                                        formik.touched.data_saida &&
                                        Boolean(formik.errors.data_saida),
                                    helperText:
                                        formik.touched.data_saida &&
                                        formik.errors.data_saida,
                                    sx: {
                                        width: {
                                            xs: '100%',
                                            sm: '170px',
                                        },

                                        '& .MuiInputBase-root': {
                                            height: '32px',
                                        },

                                        '& .MuiInputBase-input': {
                                            padding: '6px 8px',
                                            fontSize: '0.82rem',
                                        },

                                        '& .MuiInputLabel-root': {
                                            fontSize: '0.82rem',
                                            transform: 'translate(14px, 7px) scale(1)',
                                        },

                                        '& .MuiInputLabel-shrink': {
                                            transform: 'translate(14px, -7px) scale(0.75)',
                                        },

                                        '& .MuiIconButton-root': {
                                            padding: '4px',
                                        },

                                        '& .MuiSvgIcon-root': {
                                            fontSize: '18px',
                                        },
                                    },
                                },
                            }}
                        />
                    </LocalizationProvider>

                    <TextField
                        fullWidth
                        id="motivo_saida"
                        name="motivo_saida"
                        label="Motivo da saída ou desistência"
                        placeholder="Informe resumidamente o motivo"
                        variant="outlined"
                        size="small"
                        value={formik.values.motivo_saida || ''}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.motivo_saida &&
                            Boolean(formik.errors.motivo_saida)
                        }
                        helperText={
                            formik.touched.motivo_saida &&
                            formik.errors.motivo_saida
                        }
                        inputProps={{
                            maxLength: 500,
                        }}
                    />
                </Box>

                <Typography variant="h4" color={colors.pink[600]} fontWeight={'bold'} pb={1}>Dados para Emissão da NF</Typography>
                {
                    formDataStreet.map((data) => {
                        return (
                            <TextField
                                style={{ margin: '4px' }}
                                variant="outlined"
                                size="small"
                                key={data.id}
                                fullWidth
                                id={data.id}
                                name={data.name}
                                label={data.label}
                                value={data.value}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={data.error}
                                helperText={data.helpertext}
                                type={data.type}
                                inputProps={{
                                    maxLength: data.maxlenght,
                                }}
                            />
                        )
                    })
                }
                <Typography variant="h4" color={colors.pink[600]} sx={{ marginTop: '30px' }} fontWeight={'bold'} pb={1}>Dados Comercial da Vendedora</Typography>
                {
                    formDataStreetComercial.map((data) => {
                        return (
                            <TextField
                                style={{ margin: '4px' }}
                                variant="outlined"
                                size="small"
                                key={data.id}
                                fullWidth
                                id={data.id}
                                name={data.name}
                                label={data.label}
                                value={data.value}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={data.error}
                                helperText={data.helpertext}
                                type={data.type}
                                inputProps={{
                                    maxLength: data.maxlenght,
                                }}
                            />
                        )
                    })
                }
                <Typography variant="h4" color={colors.pink[600]} sx={{ marginTop: '30px' }} fontWeight={'bold'} pb={1}>Dados de Troca da Vendedora</Typography>

                <Box fullWidth
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '80px',
                        backgroundColor: 'rgba(214,211,200,0.5)',
                        borderRadius: '4px',
                        border: '1px rgba(0,0,0,0.2) solid',
                        marginLeft: '5px',
                        marginRight: '-4px',
                        padding: '6px 0px 6px 20px'
                    }}
                    mb={2}
                >

                    <FormControl component="fieldset">
                        {/* <FormLabel component="legend">Selecione uma Opção</FormLabel> */}
                        <RadioGroup value={selectedValue} onChange={handleChange} row>
                            <FormControlLabel value="outro" control={<Radio color="success" />} label="Outro" sx={{ color: 'black', fontWeight: 'bold' }} />
                            <FormControlLabel value="residencial" control={<Radio color="success" />} label="Residencial" sx={{ color: 'black', fontWeight: 'bold' }} />
                            <FormControlLabel value="comercial" control={<Radio color="success" />} label="Comercial" sx={{ color: 'black', fontWeight: 'bold' }} />
                        </RadioGroup>
                    </FormControl>
                </Box>
                {
                    formDataStreetEntrega.map((data) => {
                        return (
                            <TextField
                                style={{ margin: '4px' }}
                                variant="outlined"
                                size="small"
                                key={data.id}
                                disabled={selectedValue !== 'outro'}
                                fullWidth
                                id={data.id}
                                name={data.name}
                                label={data.label}
                                value={data.value}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={data.error}
                                helperText={data.helpertext}
                                type={data.type}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                    maxLength: data.maxlenght,
                                }}
                            />
                        )
                    })
                }
                <Typography variant="h5" color={colors.pink[600]} sx={{ marginTop: '30px' }} fontWeight={'bold'} pb={1}>Observações</Typography>
                <TextField
                    fullWidth
                    id="observacao"
                    name="observacao"
                    label="Observações"
                    variant="outlined"
                    value={formik.values.observacao}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.observacao && Boolean(formik.errors.observacao)}
                    helperText={formik.touched.observacao && formik.errors.observacao}
                    multiline          // Enables textarea
                    rows={4}           // Sets the number of rows (height) for the textarea
                />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: !isMobile ? 'center' : 'flex-end',
                        padding: '15px 0px 15px 0px',
                        gap: '10px',
                    }}>
                    <Button color="warning" variant="contained" fullWidth onClick={handleClearAll} sx={{ width: '200px', color: 'white', height: '30px' }}>
                        Cancelar
                    </Button>
                    <LoadingButton color={formik.values.id ? 'info' : 'secondary'} loadingPosition="start" variant="contained" fullWidth type="submit"
                        loading={isLoading}
                        sx={{
                            width: '200px',
                            color: 'white',               // Ensures the text color is readable
                            '&.Mui-disabled': {
                                backgroundColor: 'grey.500', // Custom disabled background color
                                color: 'white',              // Custom disabled text color
                            },
                        }}
                        disabled={!(formik.isValid && formik.dirty)}
                    >
                        {formik.values.id ? 'Atualizar' : 'Salvar'}
                    </LoadingButton>

                </Box>
            </form>
        </Box>
    );
}

export default UserForm;